/**
 * TYT Platform API
 * This is the TYT Platform API. It is used by TYT's apps to interact 
 * with the underlying platform. 
 *
 * NOTE: This file is auto generated. 
 * Do not edit this file manually.
 */


import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import * as models from '../model/models';
import { Requester } from '../requester';
import { PagedArray } from '../paged-array';

/* tslint:disable:no-unused-variable member-ordering */


@Injectable()
export class TuneInsApi {
    constructor(
        protected requester: Requester
    ) {
    }

    /**
     * Get the list of tune ins
     */
    public all(__unused?: any): Observable<PagedArray<models.ApiTuneIn>> {
        const path = '/content/tune_ins';

        let queryParameters : Record<string,string> = {};
        let headers : Record<string,string> = {}; 

        let requestMethodStr = 'RequestMethod.Get'.replace(/RequestMethod\./, '').toUpperCase();
        let requestPath = path;

        return this.requester
            .request<PagedArray<models.ApiTuneIn>>(
                requestMethodStr, 
                requestPath, 
                queryParameters,
                headers,
            );
    }

}
